<template>
  <div>
    <div class="grid-x grid-padding-y">
      <div class="large-12 cell">
        <p class="text-center">&nbsp;</p>
      </div>
    </div> 
    <div class="grid-container container first">
      <div class="grid-x grid-padding-x layout">
        <div class="cell medium-6 large-4 large-centered">
          <form data-abide novalidate ref="f" class="">
            <div class="card-section">

               <div class="text-center h4">
                <div to="" style="color: inherit;">
                  Forgot Password
                </div>
              </div>
              <div class="padding-top-1 padding-bottom-1">
<p style="font-size: 1rem;">
                  Please enter your email address to receive a password reset link. 
                </p>
              </div>

              <label>
                <input
                  name="UserName"
                  type="email"
                  placeholder="Email"
                  autofocus
                  v-model="model.UserName"
                  required
                />
                 <span class="form-error">
                  This field is required.
                </span>
              </label>

              <p style="clear: both;">&nbsp;</p>
              <p>
                <input
                  id="login"
                  name="login"
                  type="submit"
                  class="button expanded radius large"
                  value="Reset My Password"
                />
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="container"></div>
  </div>
</template>

<script>
 import accountRepository from "@/app.account/services/main-service.js";

export default {
  name: "appForgotPassword",
  mixins: [require("@/app/mixins/foundation")],
  data() {
    return {
      model: {
        UserName: this.$route.params.email || ''
      },
       isValid: false,
      loading: false,
      errored: false,
    };
  },
  mounted () {
    let _this = this;

    $(this.$refs.f)
      .on("invalid.zf.abide", function() {
        _this.isValid = false;
      })
      .on("formvalid.zf.abide", function() {
        _this.isValid = true;
      })
      .on("submit", function(ev) {
        ev.preventDefault();

        if (_this.isValid) {
          _this.onSubmit();
        } else {
          // console.log("error");
        }
      });
  },
  created () {
  },
  methods: {
    async onSubmit() {
      this.$refs.f.login.disabled = true;

      try {
          await accountRepository.preResetPassword(this.model.UserName);
          this.$router.push({name:'forgotPasswordSent', params: {
                      email: this.model.UserName
            }});
      } catch (error) {
        this.errored = true;
      } finally {
        this.loading = this.$refs.f.login.disabled = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  padding-top: 1.5rem;
  .large-centered {
    margin: 0 auto;
  }
}
.banner-description{
  background-image: linear-gradient(to bottom right, #cec9c9, white);
}
</style>
